/* Pre-launch page: the ENTER control reveals the Shopify storefront password form. */
(function () {
  var toggle = document.querySelector('[data-password-toggle]');
  var gate = document.getElementById('storefront-password');
  if (!toggle || !gate) return;

  if (document.querySelector('.prelaunch__error')) gate.hidden = false;

  toggle.addEventListener('click', function () {
    var open = gate.hidden;
    gate.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    if (open) {
      var field = gate.querySelector('input[type="password"]');
      if (!field) return;
      /* Focus after the revealed panel has been laid out, and without letting
         the focus itself scroll the page. */
      requestAnimationFrame(function () {
        try {
          field.focus({ preventScroll: true });
        } catch (e) {
          field.focus();
        }
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        gate.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
      });
    }
  });
})();

/* Pre-launch capture. Full-page POST; the success state is rendered from
   ?subscribed=1 on the way back, and the control gets an immediate pending
   state on the way out. (K P0-1) */
(function () {
  var C = window.CMCapture;
  var form = document.getElementById('prelaunch-form');
  if (!C || !form) return;

  var status = form.querySelector('[data-prelaunch-status]');
  var fields = form.querySelector('[data-prelaunch-fields]');
  var button = form.querySelector('[data-prelaunch-submit]');
  var email = form.querySelector('input[type="email"]');

  if (C.subscribed()) {
    C.consume();
    if (fields) fields.remove();
    if (status) status.textContent = 'You are on the list.';
    return;
  }

  C.bind(form, {
    validate: function () {
      if (email && !email.checkValidity()) return 'Enter a valid email address';

      /* The mobile number is required (owner, 2026-10-19). The form runs
         novalidate, so this hook is the only thing that enforces it. The
         number is checked with the same rule that would send it, so a visitor
         is never told a number is fine and then has it silently dropped.
         Ticking the consent box stays optional and is deliberately not
         checked here. */
      var phone = document.querySelector('[data-sms-phone]');
      if (phone) {
        if (!phone.value.trim()) return 'Enter a mobile number';
        if (window.CMSms && !window.CMSms.e164(phone.value)) {
          return 'That mobile number does not look right';
        }
      }
      return null;
    },
    onSending: function () {
      if (status) status.textContent = '';

      /* The SMS consent goes out HERE and nowhere else. capture-form.js fires
         onSending only once validate has passed, and only once per submit
         because it guards on cmSending, so consent can no longer be sent while
         the visitor is being shown an error, and a double submit cannot send
         twice. Both were measured happening before this moved (qa-sms 1). */
      if (window.CMSms) window.CMSms.trySend();

      C.pending(button);
    },
    onError: function (message) {
      C.restore(button);
      if (status) status.textContent = message;
    }
  });
})();
